module.exports = __webpack_public_path__ + "static/img/zhuiqiu@2x.f0c3093.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/pc/zhuiqiu@2x.png
// module id = TA1P
// module chunks = 1